<template>
  <div>
    <!-- LABELS -->
    <v-row>
      <v-col>
        <VTextField
          v-model="data.label[selectedLang]"
          :label="$t('forms.labels.label')"
          :rules="{ required: selectedLang === teamMainLang, min: 1, max: 200 }"
          data-cy="report-text"
          outlined
          dataCy="reportTypeForm-label"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <!-- NAME -->
    <v-row>
      <v-col>
        <VTextField
          v-model="data.name"
          :label="$t('forms.labels.key')"
          :rules="{ required: true, min: 1, max: 200 }"
          :disabled="isEdition"
          outlined
          dataCy="reportTypeForm-name"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <VAutocomplete
          v-model="data.roles"
          itemText="label"
          itemValue="key"
          outlined
          :label="$t('forms.labels.roles')"
          :items="rolesList"
          :multiple="true"
          :rules="{ required: true }"
          @change="updateData"
        />
      </v-col>
    </v-row>
    <!-- FOOTER TEXT -->
    <v-row>
      <v-col>
        <VTextField
          v-model="data.disclaimer[selectedLang]"
          :label="$t('forms.labels.footerText')"
          :rules="{ required: selectedLang === teamMainLang, max: 350 }"
          data-cy="reportTypeForm-footerText"
          outlined
          @input="updateData"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField';
import allRoles from '@/constants/roles';
import VAutocomplete from '@/components/shared/widgets/forms/VuetifyInputs/VAutocomplete.vue';

export default {
    components: {
        VTextField,
        VAutocomplete,
    },
    props: {
        reportData: {
            type: Object,
            default: null,
        },
        isEdition: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        data: {
            label: {},
            disclaimer: {},
            name: '',
            roles: [],
        },
    }),
    computed: {
        ...mapGetters([
            'teamLangs',
            'selectedLang',
            'teamMainLang',
        ]),
        rolesList() {
            return Object.values(allRoles).map(role => ({
                label: this.$t(`roles.${role.value}`),
                key: role.value,
            }));
        },
    },


    mounted() {
        if (this.reportData?.name) {
            this.data.name = this.reportData.name;
        }
        if (this.reportData?.label) {
            this.data.label = this.reportData.label;
        }
        if (this.reportData?.disclaimer) {
            this.data.disclaimer = this.reportData.disclaimer;
        }
        if (this.reportData?.roles) {
            this.data.roles = this.reportData.roles;
        }
    },

    methods: {
        updateData() {
            this.$emit('sendData', this.data);
        },
    },
};
</script>
